import React, { useState } from 'react'
import '../../assets/css/components/Display/Tooltip.css'

const Tooltip: React.FC<TooltipProps> = ({
  children,
  title,
  position = 'top',
  delay,
  classes,
  xOffset = 0,
  yOffset = 0,
  show = true,
  innerStyle = {},
  right = "",
  componentValue: Component,
  ...props
}) => {
  const [active, setActive] = useState(false)
  let timeout

  const getStyle = () => {
    switch (position) {
      case 'top':
        return {
          top: 'calc(-100% - 10px)',
          right: `calc(${right || '-150px'} + 50%)`,
          alignItems: 'flex-end',
          justifyContent: 'center',
        }
      case 'right':
        return {
          left: 'calc(100% + 8px)',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }
      case 'bottom':
        return {
          bottom: 'calc(-100% - 10px)',
          right: 'calc(-150px + 50%)',
          alignItems: 'flex-start',
          justifyContent: 'center',
        }
      case 'left':
        return {
          right: 'calc(100% + 8px)',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }
      // case 'top-start': return { top: 'calc(-100% - 10px)', alignItems: 'flex-end', justifyContent: 'flex-start' };
      // case 'right-start': return { right: 'calc(-100% - 10px)', alignItems: 'flex-start', justifyContent: 'flex-start' };
      // case 'bottom-start': return { bottom: 'calc(-100% - 10px)', alignItems: 'flex-start', justifyContent: 'flex-start' };
      // case 'left-start': return { left: 'calc(-100% - 10px)', alignItems: 'flex-start', justifyContent: 'flex-end' };
      // case 'top-end': return { top: 'calc(-100% - 10px)', alignItems: 'flex-end', justifyContent: 'flex-end' };
      // case 'right-end': return { right: 'calc(-100% - 10px)', alignItems: 'flex-end', justifyContent: 'flex-start' };
      // case 'bottom-end': return { bottom: 'calc(-100% - 10px)', alignItems: 'flex-start', justifyContent: 'flex-end' };
      // case 'left-end': return { left: 'calc(-100% - 10px)', alignItems: 'flex-end', justifyContent: 'flex-end' };
    }
  }

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true)
    }, delay || 100)
  }

  const hideTip = () => {
    clearInterval(timeout)
    setActive(false)
  }

  const onRenderContent = () => {
    if (Component) {
      return <div className={`tooltip ${position} bg-white`}>{<Component />}</div>
    }
    return title !== '' && <div className={`tooltip ${position}`}>{title}</div>
  }

  return (
    <div
      className={`relative ${classes}`}
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {active && show && (
        <div
          className="absolute flex items-center justify-center"
          style={{
            ...getStyle(),
            height: `calc(100% - ${yOffset}px)`,
            width: `calc(300px - ${xOffset}px)`,
            ...innerStyle
          }}
        >
          {onRenderContent()}
        </div>
      )}
      {children}
    </div>
  )
}

export default Tooltip

interface TooltipProps {
  children: any
  title: string | JSX.Element
  delay?: number
  classes?: string
  xOffset?: number
  yOffset?: number
  position?: 'top' | 'right' | 'bottom' | 'left'
  show?: boolean
  innerStyle?: React.CSSProperties
  right?: string
  componentValue?: React.FC
  // position?: 'top' | 'right' | 'bottom' | 'left' | 'top-start' | 'right-start' | 'bottom-start' | 'left-start' | 'top-end' | 'right-end' | 'bottom-end' | 'left-end'
}
